import { ProjectProps } from "types/estatesAndMap";
import { FirestoreActivityProps } from "types/firestoreFeatures";
import { MapDataActivities } from "types/mapData";

type GetActivityOptionsProps = {
  projects: ProjectProps[];
  activities: MapDataActivities;
  estateId: string;
  activityGroups?: string[];
  linkedActivity?: { projectId?: string; activityId?: string };
  mapId?: string;
  mapName?: string;
};

export type ActivityOption = {
  estateId: string;
  estateName: string;
  projectId: string;
  projectName: string;
  activityId: string;
  mapId?: string;
  mapName?: string;
  activityName: string;
  activityTypeId: string;
  biomassScreeningData: FirestoreActivityProps["biomassScreening"] | undefined;
  ownerInformation?: FirestoreActivityProps["ownerInformation"];
  tagField: string;
  label: string;
};

const getActivityOptions = ({
  projects,
  activities,
  estateId,
  activityGroups,
  linkedActivity,
  mapId,
  mapName
}: GetActivityOptionsProps) => {
  // Get projects and activities for the given estateId
  const estateProjects = projects.filter((project) => project.estateId === estateId);

  // Run through estate projects and create array of activities
  const activitiesArray: ActivityOption[] = [];
  estateProjects.forEach((project) => {
    // Unpack project parameters
    const { id: projectId, name: projectName, estateName } = project;
    const projectActivities = activities[projectId];
    if (!projectActivities) {
      return;
    }
    Object.values(projectActivities).forEach((activity) => {
      // Unpack activity parameters
      const { id: activityId, type, name, biomassScreening, ownerInformation } = activity;
      // Preserve an existing origin even when it is outside the selectable groups.
      const isLinkedActivity = linkedActivity?.projectId === projectId &&
        linkedActivity?.activityId === activityId;
      if (!isLinkedActivity && activityGroups && activityGroups.length > 0) {
        if (!type || !activityGroups.includes(type.group)) {
          return; // Skip if activity does not match the specified groups
        }
      }
      activitiesArray.push({
        estateId: estateId,
        estateName: estateName,
        projectId: projectId,
        projectName: projectName,
        activityId: activityId,
        activityName: name,
        tagField: name,
        label: `${projectName}:${name}:${activityId}`,
        activityTypeId: type ? type.id : "",
        biomassScreeningData: biomassScreening,
        mapId: mapId || "",
        mapName: mapName || "",
        ownerInformation: ownerInformation
      });
    });
  });

  return activitiesArray;
};

export default getActivityOptions;
